var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44531 12L3.44531 7L4.84531 5.55L7.44531 8.15V0H9.44531V8.15L12.0453 5.55L13.4453 7L8.44531 12ZM2.44531 16C1.89531 16 1.42448 15.8042 1.03281 15.4125C0.641146 15.0208 0.445312 14.55 0.445312 14V11H2.44531V14H14.4453V11H16.4453V14C16.4453 14.55 16.2495 15.0208 15.8578 15.4125C15.4661 15.8042 14.9953 16 14.4453 16H2.44531Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDownloadArrow);
export default __webpack_public_path__ + "static/media/icons_download_arrow.ff376510.svg";
export { ForwardRef as ReactComponent };